var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXLogoShareBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 1200 1200",
  style: {
    enableBackground: "new 0 0 1200 1200"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.x_logo_share_black_svg{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 600,
  cy: 600,
  r: 581
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "x_logo_share_black_svg",
  d: "M665.8,545.9l257.3-299.1h-61L638.7,506.5L460.2,246.8H254.4l269.9,392.7L254.4,953.2h61l235.9-274.3 l188.5,274.3h205.8L665.8,545.9L665.8,545.9z M582.2,643l-27.3-39.1L337.4,292.7H431l175.6,251.1l27.3,39.1l228.2,326.4h-93.7 L582.2,643L582.2,643z"
})));
export default SvgXLogoShareBlack;